"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Editions = require("self-service-api/constants/Editions");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _EditionSelectionButtonGroup = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/EditionSelectionButtonGroup"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var SuiteCalcEditionSelectionContainer = function SuiteCalcEditionSelectionContainer(_ref) {
  var activeEdition = _ref.activeEdition,
      activeCurrency = _ref.activeCurrency,
      setActiveEdition = _ref.setActiveEdition,
      highestOwnedEdition = _ref.highestOwnedEdition,
      activeHub = _ref.activeHub;
  (0, _react.useEffect)(function () {
    if (highestOwnedEdition !== _Editions.FREE) {
      setActiveEdition(highestOwnedEdition); // TODO i want to relocate this setting active edition on load
    }
  }, [activeHub] // this is only needed so we set activeEdition to user's appropriate edition on page load
  );

  var handleEditionUpdated = function handleEditionUpdated(edition) {
    setActiveEdition(edition);
    (0, _getUsageTracker.default)().track('clickMerchSelectionButton', {
      merchandise: "suite-" + edition,
      currency: activeCurrency
    });
  };

  return _react.default.createElement(_EditionSelectionButtonGroup.default, {
    activeEdition: activeEdition,
    onEditionUpdated: handleEditionUpdated
  });
};

SuiteCalcEditionSelectionContainer.propTypes = {
  activeEdition: _propTypes.default.string.isRequired,
  activeCurrency: _propTypes.default.string.isRequired,
  activeHub: _propTypes.default.string,
  highestOwnedEdition: _propTypes.default.string.isRequired,
  setActiveEdition: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    activeCurrency: (0, _CurrencySelectors.activeCurrencySelector)(state),
    highestOwnedEdition: (0, _ProductOwnershipSelectors.highestOwnedEditionAcrossAllHubsSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SuiteCalcEditionSelectionContainer);

exports.default = _default;
module.exports = exports.default;